import styles from "./Footer.module.css";

function Footer() {
  return (
    <footer className={styles.footer}>
      <h2>Aegis Cibersegurança &copy; Desenvolvido pelo Team EMB 2023</h2>
    </footer>
  );
}

export default Footer;
